import s from "./tabs.module.css";
import styled from "styled-components";

const Buttons = ({ setComponent, components, component }) => {
  return (
    <div className={`${s.wrapper}`}>
      {components.map((x, i) => (

          <Tab
            thisComponent={component}
            component={x}
            key={i}
            className={`${s.label} ${
              x === component ? s.darkBg : s.greyBg
            } float-end `}
            onClick={() => setComponent(x)}
          >
            {x}
          </Tab>
      ))}
    </div>
  );
};

export default Buttons;

const Tab = styled.div`
  padding-top: 0.5rem;
  @media (max-width: 350px) {
    font-size: x-small;
  }
  /* z-index: ${(props) =>
    props?.component === props?.thisComponent ? "1" : "-1"}; */
`;
